import 'ui-theme/plugins/drawer/js/drawer';
if (typeof UX.menu !== 'undefined') {
    UX.menu.vPort = ['screen-md'];

    (UX.menu.on.listPosition.start = function () {}),
        (UX.menu.on.listPosition.handleHeightSet = function () {}),
        (UX.menu.on.listPosition.reset = function () {});
}
